import KeyValuePair from '@/modules/core/support/KeyValuePair';
import AppRelease from '@/modules/app-router/model/AppRelease';
import AppModule from '@/modules/app-router/model/AppModule';

/**
 * Aplicación registrada en el enrutador
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class App {
    public id = 0
    public name = ''
    public domain = ''
    public releases: AppRelease[] = []

    /**
     * Módulos registrados para la aplicación
     *
     * @var { AppModule[] }
     */
    public modules: AppModule[] = []

    public api = 0

    /**
     * Indica si la entidad es nueva y aún no ha sido registrada
     * en el servidor
     */
    public get isNew () {
        return !this.id
    }

    /**
     * Crea una entidad App a partir del objeto plano obtenido desde la API
     *
     * @param data
     */
    public static deserialize (data: KeyValuePair) {
        const app = Object.assign(new this(), {
            id: data.id,
            name: data.name,
            domain: data.domain,
            api: data.api,
            releases: data.releases.map((r: KeyValuePair) => AppRelease.deserialize(r)),
        })

        if (Array.isArray(data.releases)) {
            app.releases =  data.releases.map((r: KeyValuePair) => AppRelease.deserialize(r))
        }

        if (Array.isArray(data.modules)) {
            app.modules = data.modules.map((m: KeyValuePair) => AppModule.deserialize(m))
        }

        return app
    }
}
